// Implements simple account/session actions through the Supabase browser auth boundary.
import { supabase } from '@/integrations/supabase/client';
import type { AuthAccountPort } from '../core/types';

export function createSupabaseAuthAccountPort(): AuthAccountPort {
  return {
    async signOut() {
      await supabase.auth.signOut();
    },

    async getCurrentUserId() {
      const { data: { user } } = await supabase.auth.getUser();
      return user?.id ?? null;
    },
  };
}
